export enum FooterMoreActionsOptions {
  approve = 'approve',
  edit = 'edit',
  markPending = 'markPending',
}
